import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Navigation } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

export function DirectionsDialog({ 
  open, 
  onOpenChange, 
  destination, 
  origin, 
  onOriginChange, 
  onGetDirections,
  compact = false 
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className={compact ? "max-w-[calc(100vw-2rem)]" : "sm:max-w-md"}>
        <DialogHeader>
          <DialogTitle className="font-serif text-lg flex items-center gap-2">
            <Navigation className="w-5 h-5 text-accent" />
            Get Directions
          </DialogTitle>
          {!compact && destination && (
            <DialogDescription>
              Directions to {destination.name}, {destination.state}
            </DialogDescription>
          )}
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <label className="text-sm font-medium mb-2 block">Starting Location (Optional)</label>
            <Input
              placeholder={compact ? "Enter your address" : "Enter your city or address"}
              value={origin}
              onChange={(e) => onOriginChange(e.target.value)}
              className={compact ? "h-10" : "h-12"}
              data-testid="directions-origin-input"
            />
            <p className="text-xs text-muted-foreground mt-1">
              Leave empty {compact ? 'for' : 'to use your'} current location
            </p>
          </div>
          <div className="flex gap-2">
            <Button variant="outline" className="flex-1" onClick={() => onOpenChange(false)}>
              Cancel
            </Button>
            <Button 
              className="flex-1 bg-accent text-accent-foreground hover:bg-accent/90" 
              onClick={onGetDirections}
              data-testid="open-directions-btn"
            >
              <Navigation className="w-4 h-4 mr-1" />
              Go
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
